import { api } from "@/lib/api";

const toKey = (b64) => {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export async function registerPush() {
  if (!pushSupported()) return false;
  if (Notification.permission === "default") await Notification.requestPermission();
  if (Notification.permission !== "granted") return false;
  const reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { data } = await api.get("/push/vapid");
    if (!data.public_key) return false;
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toKey(data.public_key) });
  }
  await api.post("/push/subscribe", { subscription: sub.toJSON() });
  return true;
}

export async function isPushActive() {
  if (!pushSupported() || Notification.permission !== "granted") return false;
  const reg = await navigator.serviceWorker.getRegistration("/sw.js");
  return !!(reg && (await reg.pushManager.getSubscription()));
}
